import type { IconData } from '@stacksjs/iconify-core'

export const basicUiSearch: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7a7 7 0 1 1 13.218 3.218L16 13l-3 3l-2.782-2.782A7 7 0 0 1 0 7m7 3a3 3 0 1 1 0-6a3 3 0 0 1 0 6\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiSearch
